import { render, staticRenderFns } from "./StoperPrices.vue?vue&type=template&id=730c5d74&scoped=true&"
import script from "./StoperPrices.vue?vue&type=script&lang=js&"
export * from "./StoperPrices.vue?vue&type=script&lang=js&"
import style0 from "./StoperPrices.vue?vue&type=style&index=0&id=730c5d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c5d74",
  null
  
)

export default component.exports